import { render, staticRenderFns } from "./VerClientesAlimentacao.vue?vue&type=template&id=5a1b1792&"
import script from "./VerClientesAlimentacao.vue?vue&type=script&lang=js&"
export * from "./VerClientesAlimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports